import qwest from 'qwest';

import FollowUp from '../models/followUp.jsx';

let followUpApi = {
  getFollowUp(analysisID) {
    return new Promise((resolve, reject) => {
      qwest.get(`/FollowUp?analysisID=${analysisID}`)
        .then((xhr, response) => {
          if (response.success) {
            resolve(FollowUp.fromApiFormat(response.data));
          } else {
            reject(response);
          }
        });
    });
  },

  saveFollowUp(followUp) {
    return new Promise((resolve, reject) => {
      qwest.post('/FollowUp', followUp.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            resolve(FollowUp.fromApiFormat(response.data));
          } else {
            reject(response);
          }
        });
    });
  },

  followUp(id) {
    return new Promise((resolve, reject) => {
      qwest.get(`/FollowUp/FollowUp?id=${id}`)
        .then((xhr, response) => {
          if (response.success) {
            resolve(response.data);
          } else {
            reject(response);
          }
        });
    });
  },

  dismiss(id) {
    return new Promise((resolve, reject) => {
      qwest.get(`/FollowUp/Dismiss?id=${id}`)
        .then((xhr, response) => {
          if (response.success) {
            resolve(response.data);
          } else {
            reject(response);
          }
        });
    });
  },

  revert(id) {
    return new Promise((resolve, reject) => {
      qwest.get(`/FollowUp/Revert?id=${id}`)
        .then((xhr, response) => {
          if (response.success) {
            resolve(response.data);
          } else {
            reject(response);
          }
        });
    });
  },

  deleteFollowUp(followUp) {
    return new Promise((resolve, reject) => {
      qwest.delete('/FollowUp', followUp.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            resolve(FollowUp.fromApiFormat(response.data));
          } else {
            reject(response);
          }
        });
    });
  },
};

export default followUpApi;
